import {
  Modal,
  Box,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { putRequest, useMutationWrapper } from "services/apiHelper";
import { convertParamsToString } from "helpers/stringManipulation";
import { scriptsRequest } from "services/request";
import { QUERY_KEYS, type ScriptType, statusOBJ } from "utils/constants";
import { successToast } from "utils/hooks";
import { BsCheckCircle } from "react-icons/bs";
import { RiErrorWarningFill } from "react-icons/ri";
import { queryClient } from "App";
import { useState } from "react";

interface VerifyModalProps {
  isOpen: boolean;
  onClose: () => void;
  isApproved: boolean;
  script: ScriptType;
}

const VerifyModal = (props: VerifyModalProps) => {
  const { isOpen, onClose, isApproved = true, script } = props;
  const [reason, setReason] = useState("");

  const onSuccess = () => {
    void queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.ADMIN_SCRIPTS] });

    onClose();
    successToast(isApproved ? `${script.name} has been published..👏🏻 ` : "Deleted Successfully");
  };
  const { APPROVED, REJECTED } = statusOBJ;
  const { mutate, isLoading } = useMutationWrapper(putRequest, onSuccess);
  const handleScriptVerification = () => {
    const url = convertParamsToString(scriptsRequest.SCRIPTS_VERIFY, { id: script.id });

    mutate({
      url,
      data: {
        status: isApproved ? APPROVED : REJECTED,
        composerId: script.composerId,
        others: reason,
      },
    });
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent alignItems="center">
        <ModalCloseButton />
        <ModalBody pb={6}>
          <Box mt="20px" w="200px" h="100px" ml="70px">
            {isApproved ? (
              <BsCheckCircle size="100px" color="#B5F4AF " />
            ) : (
              <RiErrorWarningFill size="100px" color="#F5582A " />
            )}
          </Box>
          <Text fontSize="20px" fontWeight="800" ml="60px" mt="30px">
            {isApproved ? "Verify" : "Reject"} Script
          </Text>
          <Text mt="30px">You will not be able to revert this!!!</Text>
          <Textarea
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
            }}
            placeholder="Enter reason..."
            size="lg"
            mt="10px"
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={handleScriptVerification} mr={3} isLoading={isLoading} p="20px">
            {isApproved ? "Yes, verify it!" : "Yes, reject it!"}
          </Button>
          <Button onClick={onClose} background="red" p="20px">
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default VerifyModal;
